import { React, useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const Germany = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Country"    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Country"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const countries = [
        {
            img: "images/Arden-University.webp", universityname: "Global University Systems (GUS) – Arden University", location: "Berlin, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$11018", para2: "NA", para3: "NA"
        },
        {
            img: "images/Fresenius.webp", universityname: "Fresenius University of Applied Sciences – Munich Campus", location: "Bavaria, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12844", para2: "NA", para3: "NA"
        },
        {
            img: "images/Fresenius.webp", universityname: "Fresenius University of Applied Sciences – Hamburg Campus", location: "Hamburg, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12844", para2: "NA", para3: "NA"
        },
        {
            img: "images/Fresenius.webp", universityname: "Fresenius University of Applied Sciences – Duesseldorf Campus", location: "North Rhine-Westphalia, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12844", para2: "NA", para3: "NA"
        },
        {
            img: "images/Fresenius.webp", universityname: "Fresenius University of Applied Sciences – Cologne Campus", location: "North Rhine-Westphalia, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12844", para2: "NA", para3: "NA"
        },
        {
            img: "images/Fresenius.webp", universityname: "Fresenius University of Applied Sciences – Berlin Campus", location: "Berlin, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$10325", para2: "NA", para3: "NA"
        },
        {
            img: "images/EU-Business-School-canam.webp", universityname: "EU Business School – Munich Campus", location: "Bavaria, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$14795", para2: "NA", para3: "NA"
        },
        {
            img: "images/CBS-International-Business-School.webp", universityname: "CBS International Business School – Cologne Campus", location: "North Rhine-Westphalia, Germany", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12300", para2: "NA", para3: "NA"
        }

    ]
    return (
        <>
            <BannerBreadcrumb head={"International Student Universities in Germany"} pagename={"Germany"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">Germany is the Ideal Destination for International Students</h5>
                            <p className="loan-elegibility-des">Germany’s excellent educational opportunities, inexpensive or low tuition, and thrilling cultural experiences have made it an appealing option for international students. Germany is a desirable location for learners to thrive because of its top-notch programs in a variety of subjects provided by universities like Heidelberg University and Ludwig Maximilian University of Munich. International students enjoy an extensive network of research, industry, and a wealth of internships and employment opportunities after graduation.</p>
                            <h5 className="about-head">Financial Support for International Students</h5>
                            <p className="loan-elegibility-des">Even though tuition in Germany is inexpensive, students frequently want extra financial aid to cover living expenses. International students may submit applications for scholarships from multiple universities based on need or merit. Talented students around the world are supported by prominent scholarship programs such as the German Academic Exchange Service (DAAD). With the aid of our platform, you can quickly examine different loan possibilities from credible financial institutions to find the one that best suits your goals and financial circumstances.</p>
                            <h5 className="about-head">Credere Finance: Connecting Goals with Achievement</h5>
                            <p className="loan-elegibility-des">Credere provides personalized educational finance solutions to enable students to follow their aspirations. Students may obtain loan facilities through a simple application process, which lowers the cost of studying overseas. Credere Finance makes sure that financial constraints don’t prevent accomplishment, whether that means paying for tuition, accommodation, or travel.</p>
                            <h5 className="about-head mb-4">Explore Our List of German Universities</h5>
                            <div className="row">
                                {countries.map((item, index) => (
                                    <div className="col-md-6">
                                        <div className="scholar-card">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <img src={item.img} alt="University Images" className="img-fluid countryimg" />
                                                </div>
                                                <div className="col-md-9 d-block my-auto">
                                                    <h5 className="scholar-head">{item.universityname}</h5>

                                                </div>
                                                <p className="scholar-des mb-0 mt-4" style={{ marginLeft: "-6px", fontSize: "16px" }}><LocationPinIcon /> {item.location}</p>
                                                <div className="col-md-12 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head1}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para1}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head2}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para2}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head3}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades mb-0">{item.para3}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Germany;